import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import { Box, Button as MuiButton, Paper, Tooltip } from '@mui/material'
import { FC, useState } from 'react'
import { useTranslate } from 'react-admin'

export const CopyBlock: FC<{ content: string }> = ({ content }) => {
  const translate = useTranslate()
  const [copied, setCopied] = useState(false)

  const handleCopy = () => {
    navigator.clipboard.writeText(content)
      .then(() => { setCopied(true); setTimeout(() => setCopied(false), 2000) })
      .catch(() => { /* fallback: browser blocked clipboard */ })
  }

  return (
    <Box sx={{ position: 'relative' }}>
      <Paper
        variant="outlined"
        sx={{
          p: 2, pr: 6, bgcolor: 'grey.900', color: 'grey.100',
          fontFamily: '"JetBrains Mono", "Fira Code", "Consolas", monospace',
          fontSize: '0.8rem', lineHeight: 1.6, whiteSpace: 'pre-wrap',
          wordBreak: 'break-all', overflow: 'auto', maxHeight: 400,
          borderRadius: '10px', borderColor: 'grey.800',
        }}
      >
        {content}
      </Paper>
      <Tooltip title={copied ? translate('data.copied') : translate('data.copy')} placement="left">
        <MuiButton
          size="small"
          onClick={() => void handleCopy()}
          color={copied ? 'success' : 'inherit'}
          sx={{
            position: 'absolute', top: 8, right: 8,
            minWidth: 32, width: 32, height: 32, p: 0, color: 'grey.400',
          }}
        >
          {copied ? <CheckCircleOutlineIcon fontSize="small" /> : <ContentCopyIcon fontSize="small" />}
        </MuiButton>
      </Tooltip>
    </Box>
  )
}
